import { ObjectFieldType } from "@certa/studio-core/src/types/studioObject.types";
import { FieldType } from "@certa/types";

export const ObjectFieldIcons: Record<
  Exclude<ObjectFieldType, ObjectFieldType.FOREIGN_KEY>,
  string
> = {
  [ObjectFieldType.TEXT]: "Characters",
  [ObjectFieldType.INTEGER]: "Number",
  [ObjectFieldType.DECIMAL]: "Number",
  [ObjectFieldType.BOOLEAN]: "Boolean",
  [ObjectFieldType.ARRAY]: "Array",
  [ObjectFieldType.EMAIL]: "Envelope",
  [ObjectFieldType.URL]: "Link",
  [ObjectFieldType.PHONE_NUMBER]: "Phone",
  [ObjectFieldType.COUNTRY]: "Globe",
  [ObjectFieldType.ROLLUP]: "MathOperations",
  [ObjectFieldType.DATE]: "Date",
  [ObjectFieldType.DATE_TIMEZONE_AWARE]: "Date",
  [ObjectFieldType.OWNER]: "UserCircle",
  [ObjectFieldType.SCREENING]: "Verified",
  [ObjectFieldType.DATA_MONITORING_IDENTIFIER]: "Search",
  [ObjectFieldType.DATA_MONITORING_FIELD]: "Monitor",
  [ObjectFieldType.FILE]: "Upload"
};

export const FieldIcons = {
  [FieldType.ARRAY]: "Array",
  [FieldType.BOOLEAN]: "Boolean",
  [FieldType.BUSINESS_UNIT]: "Vendor",
  [FieldType.CASCADER]: "Cascader",
  [FieldType.CHAR]: "Characters",
  [FieldType.CHECKBOX]: "Checkbox",
  [FieldType.CURRENCY]: "Currency",
  [FieldType.NAIVE_DATE]: "Date",
  [FieldType.DATE]: "Date",
  [FieldType.DOWNLOAD_ATTACHMENT]: "Download",
  [FieldType.DROPDOWN_SINGLE]: "Multiselect",
  [FieldType.DROPDOWN_MULTI]: "Multiselect",
  [FieldType.DYNAMIC_GROUP_JSON]: "Code",
  [FieldType.EMAIL]: "Envelope",
  [FieldType.OWNER]: "UserCircle",
  [FieldType.EMBED_VIDEO]: "Video",
  [FieldType.GROUPED_CHECKBOX]: "Checkbox",
  [FieldType.INFO_DESCRIPTION_BOX]: "Info",
  [FieldType.JSON]: "Code",
  [FieldType.LC_MESSAGE]: "Envelope",
  [FieldType.DECIMAL]: "Number",
  [FieldType.INTEGER]: "Number",
  [FieldType.PARAGRAPH]: "Paragraph",
  [FieldType.PDF_LINK]: "PDF",
  [FieldType.PHONE]: "Phone",
  [FieldType.PROCESS_LINKING_ALPHA]: "Link",
  [FieldType.RADIO]: "Radio",
  [FieldType.REGION]: "Location",
  [FieldType.RICH_TEXT_EDITOR]: "Code",
  [FieldType.SECTION_BREAK]: "Break",
  [FieldType.SLIDER]: "Slider",
  [FieldType.SUPPLIER_CREATION]: "Vendor",
  [FieldType.SYSTEM]: "Gear",
  [FieldType.TABLE]: "Table",
  [FieldType.FREE_TEXT]: "Text",
  [FieldType.FILE]: "Upload",
  [FieldType.MULTI_FILE]: "Upload",
  [FieldType.URL]: "Link",
  [FieldType.VISUALIZATION]: "Gauge",
  [FieldType.WHITESPACE]: "HorizontalSpace",
  [FieldType.WIZARD_SECTION]: "Wizard",
  [FieldType.WORD_DOCUMENT]: "Word",
  [FieldType.PDF_VIEWER]: "PDF",

  // Integrations
  [FieldType.GOOGLE_ADDRESS_SEARCH]: "Globe",
  [FieldType.DNB_DUNS_SEARCH]: "Puzzle",
  [FieldType.DNB_DUNS_SEARCH_DIRECT_PLUS]: "Puzzle",
  [FieldType.DNB_COMPANY_PROFILE]: "Puzzle",
  [FieldType.DNB_RISK_SCORE]: "Puzzle",
  [FieldType.DNB_UBO]: "Puzzle",
  [FieldType.DNB_UBO1]: "Puzzle",
  [FieldType.DNB_UBO_GRAPH]: "Puzzle",
  [FieldType.DNB_DIRECTORS]: "Puzzle",
  [FieldType.DNB_RDC]: "Puzzle",
  [FieldType.DNB_RDC1]: "Puzzle",
  [FieldType.DNB_RDC_ALERTS]: "Puzzle",
  [FieldType.DNB_CMP_ENT_VW]: "Puzzle",
  [FieldType.DNB_CMPCVF]: "Puzzle",
  [FieldType.DNB_FAMILYTREE]: "Puzzle",
  [FieldType.DNB_FAMILYTREE_BRANCH]: "Puzzle",
  [FieldType.DNB_DATA_READER]: "Puzzle",
  [FieldType.DNB_FINANCIALS]: "Puzzle",
  [FieldType.DNB_LITIGATION]: "Puzzle",
  [FieldType.IBAN_SEARCH]: "Puzzle",
  [FieldType.EU_VAT_CHECK]: "Puzzle",
  [FieldType.US_TIN_CHECK]: "Puzzle",
  [FieldType.CHARITY_CHECK]: "Puzzle",
  [FieldType.WHOIS_SEARCH]: "Puzzle",
  [FieldType.CLEARBIT_SEARCH]: "Puzzle",
  [FieldType.CSV_SEARCH]: "Puzzle",
  [FieldType.LN_SEARCH]: "Puzzle",
  [FieldType.SALESFORCE]: "Puzzle",
  [FieldType.GOOGLE_SEARCH]: "Puzzle",
  [FieldType.TRANSLATION]: "Puzzle",
  [FieldType.TRANSLITERATION]: "Puzzle",
  [FieldType.THOMSON_REUTERS_GROUP]: "Puzzle",
  [FieldType.THOMSON_REUTERS_CASE]: "Puzzle",
  [FieldType.THOMSON_REUTERS_SCREEN]: "Puzzle",
  [FieldType.THOMSON_REUTERS_SCREEN_SYNC]: "Puzzle",
  [FieldType.THOMSON_REUTERS_SCREENRESULT]: "Puzzle",
  [FieldType.THOMSON_REUTERS_WCPROFILE]: "Puzzle",
  [FieldType.THOMSON_REUTERS_CASESYSTEMID]: "Puzzle",
  [FieldType.THOMSON_REUTERS_RESOLVE_RESULT]: "Puzzle",
  [FieldType.HERMES]: "Puzzle",
  [FieldType.HERMES_2]: "Puzzle",
  [FieldType.HERMES_DNB_DIVERSITY_2]: "Puzzle",
  [FieldType.CHILD_WORKFLOW]: "Puzzle",
  [FieldType.DUPLICATE_CHECK]: "Puzzle",
  [FieldType.APPBUILDER_DUPLICATE_CHECK]: "Puzzle",
  [FieldType.CSI]: "Puzzle",
  [FieldType.BOEING_SCREENING_STATUS]: "Puzzle",
  [FieldType.BOEING_ADJUDICATION_STATUS]: "Puzzle",
  [FieldType.DNB_GBO]: "Puzzle",
  [FieldType.RDC_EVENT_DETAILS]: "Puzzle",
  [FieldType.GREYLIST_CHECK]: "Puzzle",
  [FieldType.PM_GREYLIST_CHECK]: "Puzzle",
  [FieldType.RDC_ALERT_METADATA]: "Puzzle",
  [FieldType.DNB_INITIATE_INVESTIGATION]: "Puzzle",
  [FieldType.DNB_INVESTIGATION_STATUS]: "Puzzle",
  [FieldType.OCR]: "Puzzle",
  [FieldType.DOCUSIGN]: "Puzzle",
  [FieldType.KRYPTON_AI_PUSH]: "Puzzle",
  [FieldType.ADOBE_SIGN]: "Puzzle",
  [FieldType.AMBER_ROAD]: "Puzzle",
  [FieldType.CREATE_REUSABLE_COMPONENT]: "Puzzle",
  [FieldType.CODE_MIGRATION]: "Puzzle",
  [FieldType.PLATFORM_SETTINGS]: "Puzzle",
  [FieldType.WORKFLOW_STATUS]: "Puzzle",
  [FieldType.INTEGRATION_WORD_DOCUMENT_DOWNLOAD]: "Puzzle",
  [FieldType.DOCUSIGN_DOWNLOAD]: "Puzzle",
  [FieldType.RDC_STOP_INQ]: "Puzzle",
  [FieldType.JUXTAPOSE]: "Puzzle",
  [FieldType.IMAGE]: "Puzzle",
  [FieldType.WORKDAY]: "Puzzle",
  [FieldType.HERMES_DNB_DIVERSITY]: "Puzzle",
  [FieldType.COMPLY_EXCHANGE]: "Puzzle",
  [FieldType.WORKFLOW_LOGO]: "Puzzle",
  [FieldType.PACKAGE_DEPLOY]: "Puzzle",
  [FieldType.CODEDEPLOY_TO_ENV]: "Puzzle",
  [FieldType.PUBLISHING]: "Puzzle",
  [FieldType.E_SIGNATURE]: "Puzzle"
};
